import React from 'react'

export const TrixSvg = () => {
    return (
<svg viewBox="0 0 1024 1024" width="1.5em" height="1.5em" fill="currentColor" >
<g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"  >
<path d="M4905 9260 c-490 -29 -892 -130 -1266 -316 -286 -144 -523 -315 -739
-534 -415 -420 -716 -980 -940 -1748 -11 -39 -68 -255 -125 -480 -121 -475
-171 -639 -305 -1001 -148 -403 -217 -636 -256 -876 -26 -153 -26 -472 -1
-605 22 -117 74 -274 123 -372 182 -364 550 -655 943 -744 112 -25 267 -32
329 -15 26 8 42 5 85 -14 145 -66 358 -108 552 -108 189 0 394 35 546 93 l50
18 -6 -76 c-11 -148 -19 -161 -135 -235 -145 -91 -286 -149 -730 -299 -560
-189 -710 -261 -879 -422 -122 -117 -210 -273 -248 -437 -13 -58 -13 -78 -4
-110 16 -53 65 -106 109 -119 26 -8 989 -10 3153 -8 l3116 3 35 27 c76 58 84
145 30 303 -44 126 -106 227 -197 321 -165 169 -335 253 -900 444 -488 165
-716 262 -804 340 -23 19 -30 36 -34 73 -4 46 -4 48 17 43 53 -15 218 -36 287
-36 97 0 242 25 344 59 l81 27 44 -24 c42 -22 53 -23 160 -19 194 8 394 79
546 194 26 19 47 24 115 28 250 11 546 191 732 443 144 197 222 434 234 712
12 297 -24 453 -275 1190 -140 410 -215 706 -307 1216 -109 609 -179 915 -260
1152 -126 370 -252 620 -427 847 -94 123 -266 292 -370 363 -189 129 -420 212
-590 212 l-64 0 -69 71 c-217 219 -558 349 -1065 403 -177 19 -460 26 -635 16z
m540 -320 c309 -27 545 -84 745 -183 86 -42 119 -65 182 -127 102 -101 130
-160 136 -286 5 -111 -11 -173 -76 -297 -57 -109 -140 -214 -269 -338 -355
-345 -917 -618 -1843 -899 -649 -197 -951 -340 -1262 -599 -164 -138 -325
-331 -343 -413 -5 -20 -11 -28 -21 -24 -8 3 -44 11 -79 18 -135 24 -284 -29
-385 -139 -200 -219 -259 -676 -135 -1050 138 -414 429 -658 796 -666 l78 -2
27 -70 c74 -191 183 -386 316 -565 81 -109 304 -333 396 -400 34 -24 62 -48
62 -52 0 -11 -144 -54 -239 -72 -106 -20 -302 -21 -417 -1 -114 20 -195 46
-317 102 -108 50 -141 52 -192 11 -24 -18 -35 -20 -99 -15 -94 8 -232 49 -327
96 -321 161 -544 456 -604 800 -20 110 -19 323 1 457 34 228 102 466 239 829
142 377 202 577 345 1145 132 526 254 875 426 1219 155 310 304 529 494 725
225 232 429 382 705 516 335 163 659 248 1090 283 96 8 460 6 570 -3z m1496
-530 c382 -155 685 -547 884 -1145 86 -261 137 -487 256 -1130 82 -447 99
-533 116 -583 3 -9 -10 6 -30 33 -46 66 -90 106 -160 149 -60 35 -167 66 -231
66 -34 0 -36 2 -36 35 0 111 -56 401 -112 574 -95 300 -194 489 -460 888 -221
332 -292 458 -367 646 l-31 77 26 98 c21 76 27 123 28 214 l1 117 25 -6 c14
-3 55 -18 91 -33z m-296 -865 c37 -66 138 -228 225 -360 203 -307 277 -431
350 -580 238 -491 283 -1021 165 -1940 -69 -531 -164 -820 -369 -1120 -73
-107 -261 -304 -371 -390 -309 -241 -743 -447 -1095 -522 -135 -28 -440 -26
-585 5 -304 65 -725 256 -1000 455 -396 286 -641 658 -758 1152 -49 203 -96
528 -122 835 -16 190 -21 561 -9 682 l7 69 91 77 c93 80 199 162 208 162 3 0
0 -17 -8 -37 -15 -43 -18 -109 -6 -117 5 -3 33 16 63 42 84 73 123 100 202
138 128 60 196 76 362 81 167 6 291 -9 455 -52 109 -30 151 -31 206 -6 51 23
85 70 92 126 6 61 -3 89 -43 134 -41 45 -106 76 -225 106 l-85 22 150 47 c473
148 768 260 1047 398 380 187 574 321 818 568 85 86 158 153 162 150 3 -3 36
-59 73 -125z m-3961 -2098 l73 -37 7 -157 c8 -188 29 -404 57 -603 21 -152 55
-353 65 -382 6 -21 -25 -24 -95 -7 -117 27 -256 137 -329 261 -128 217 -164
495 -97 753 55 208 146 257 319 172z m5205 4 c46 -36 95 -127 121 -226 31
-114 38 -304 15 -416 -46 -229 -175 -428 -328 -506 -27 -13 -51 -22 -54 -20
-2 3 7 77 21 164 45 276 74 559 92 904 5 106 8 118 27 127 30 15 66 6 106 -27z
m529 -631 c135 -375 210 -642 233 -824 16 -131 7 -317 -21 -421 -73 -271 -262
-497 -498 -596 -42 -17 -102 -34 -134 -37 -50 -4 -60 -2 -75 16 -10 12 -30 24
-45 27 -22 6 -35 -2 -85 -47 -107 -99 -235 -171 -358 -203 -90 -23 -105 -21
-105 15 0 43 -24 96 -50 110 -23 12 -14 16 -161 -64 -160 -86 -317 -124 -459
-112 -130 12 -130 12 -49 62 124 77 260 185 388 309 251 244 407 487 535 836
16 45 19 47 64 54 74 10 212 60 281 100 123 72 261 227 336 375 74 146 112
297 122 478 3 67 7 121 8 120 2 -2 34 -91 73 -198z m-4058 -2306 c222 -101
480 -176 700 -203 285 -36 629 13 934 133 50 20 91 34 92 33 2 -1 8 -60 14
-130 l12 -128 -27 -39 c-42 -61 -154 -167 -226 -215 -288 -193 -734 -239
-1139 -119 -190 57 -411 193 -510 314 l-37 45 20 188 c14 124 24 186 31 183 6
-2 67 -30 136 -62z m-323 -622 c204 -203 451 -331 772 -399 115 -25 147 -27
351 -27 259 -1 349 11 542 75 224 73 384 173 545 342 l93 97 119 -60 c66 -33
160 -76 208 -96 48 -20 89 -37 91 -39 1 -1 -13 -35 -32 -76 -61 -132 -119
-332 -150 -511 l-7 -38 -1429 0 -1430 0 -4 23 c-44 218 -93 380 -156 514 -22
47 -40 87 -40 88 0 1 55 25 123 54 67 28 163 74 212 101 50 27 91 49 92 50 0
0 45 -44 100 -98z m3283 -294 c218 -74 409 -159 506 -226 79 -54 194 -175 194
-204 0 -5 -252 -8 -560 -8 -498 0 -560 2 -560 15 0 71 65 294 122 417 48 103
11 103 298 6z m-4081 15 c60 -110 114 -276 135 -410 l6 -43 -560 0 c-308 0
-560 3 -560 6 0 4 16 28 36 55 74 101 185 181 354 255 100 44 517 193 542 194
10 0 28 -22 47 -57z"/>
<path d="M6235 6504 c-164 -29 -300 -85 -343 -141 -23 -31 -27 -46 -27 -97 0
-73 25 -115 85 -146 54 -28 94 -25 251 14 238 60 394 67 576 25 147 -33 277
-101 391 -202 78 -70 90 -63 72 44 -52 305 -395 522 -820 518 -58 0 -141 -7
-185 -15z"/>
<path d="M3900 5823 c-54 -9 -158 -47 -225 -81 -104 -54 -231 -184 -279 -284
-66 -138 -72 -312 -16 -443 23 -55 66 -115 80 -115 6 0 7 50 4 123 -10 205 32
323 161 452 124 124 274 182 445 172 316 -18 545 -257 603 -630 8 -48 17 -91
21 -94 20 -20 35 61 36 189 1 360 -184 617 -504 698 -75 19 -249 26 -326 13z"/>
<path d="M6374 5816 c-243 -55 -428 -227 -504 -471 -34 -110 -40 -367 -10
-415 16 -24 26 2 34 78 9 101 31 177 82 281 38 77 62 110 128 176 125 126 244
175 426 175 171 0 287 -47 405 -165 78 -78 125 -157 150 -255 14 -52 16 -90
12 -192 -4 -82 -3 -128 4 -128 5 0 23 21 39 46 105 165 97 426 -16 598 -75
112 -203 208 -338 252 -68 23 -103 28 -216 30 -90 2 -155 -1 -196 -10z"/>
<path d="M4029 5487 c-101 -29 -195 -112 -240 -212 -18 -40 -23 -69 -23 -145
-1 -88 1 -100 32 -162 37 -76 92 -130 168 -165 214 -98 434 4 499 231 48 166
-37 357 -192 432 -65 32 -172 41 -244 21z"/>
<path d="M6343 5486 c-104 -34 -176 -98 -222 -196 -22 -48 -26 -68 -26 -155 1
-119 23 -187 86 -258 95 -109 280 -143 415 -76 53 27 133 109 162 165 89 174
9 415 -165 501 -67 32 -183 41 -250 19z"/>
<path d="M5225 4559 c-139 -15 -238 -62 -325 -155 -61 -66 -79 -108 -66 -159
10 -39 57 -85 97 -94 48 -11 91 4 161 58 129 97 253 95 382 -6 50 -39 67 -47
112 -51 62 -5 94 10 124 61 26 43 25 78 -5 136 -70 140 -281 232 -480 210z"/>
<path d="M4249 3943 c-58 -36 -77 -119 -40 -178 23 -39 166 -137 302 -208 484
-254 1010 -260 1500 -17 165 82 318 189 344 240 42 82 -21 180 -117 180 -25 0
-63 -20 -148 -76 -183 -120 -365 -200 -550 -240 -120 -26 -400 -26 -520 -1
-204 44 -381 121 -564 247 -110 76 -153 87 -207 53z"/>
</g>
</svg>
)
}

export default TrixSvg
